import { FoaPart, Regulation } from "../../../../../autogen/bff-api";

export const PART_II_SHORT_DEADLINE_DAYS = 3;

const DAY_MS = 86_400_000;

export const isFoaPartII = (regulation: Regulation | null | undefined, foaPart: FoaPart | null | undefined): boolean =>
  (regulation ?? Regulation.Foa) === Regulation.Foa && foaPart === FoaPart.PartIi;

export const usesEspd = (context: {
  regulation?: Regulation | null;
  foaPart?: FoaPart | null;
  espdEnabled?: boolean | null;
}): boolean => !isFoaPartII(context.regulation, context.foaPart) || context.espdEnabled !== false;

export const isShortPartIIDeadline = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
  deadlineIso: string | null | undefined,
  announcedAt: number = Date.now(),
): boolean =>
  isFoaPartII(regulation, foaPart) &&
  deadlineIso != null &&
  new Date(deadlineIso).getTime() < announcedAt + PART_II_SHORT_DEADLINE_DAYS * DAY_MS;

export const isPartIIDeadlineNotAfterAnnouncement = (
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
  deadlineIso: string | null | undefined,
  announcedAt: number = Date.now(),
): boolean =>
  isFoaPartII(regulation, foaPart) && deadlineIso != null && new Date(deadlineIso).getTime() <= announcedAt;
